export const styles = {
    /* ── Overlay ── */
    overlay: {
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1055,
        padding: '16px',
    },

    /* ── Modal shell ── */
    modal: {
        background: '#fff',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '560px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '92vh',
        overflow: 'hidden',
    },

    /* ── Header ── */
    modalHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '18px 24px 16px',
        borderBottom: '1px solid #e5e7eb',
        background: '#fff',
        flexShrink: 0,
    },
    headerLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    titleIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '9px',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxShadow: '0 2px 8px rgba(26,125,62,0.25)',
    },
    modalTitle: {
        fontSize: '16px',
        fontWeight: '700',
        color: '#111827',
        margin: 0,
    },
    modalSubtitle: {
        fontSize: '12px',
        color: '#9ca3af',
        fontWeight: '400',
        marginTop: '1px',
    },
    btnClose: {
        width: '32px',
        height: '32px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        background: '#f9fafb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: '#6b7280',
        fontSize: '16px',
        lineHeight: 1,
        transition: 'all 0.15s ease',
        flexShrink: 0,
    },

    /* ── Body ── */
    modalBody: {
        padding: '22px 24px',
        overflowY: 'auto',
        flex: 1,
        background: '#fafafa',
    },

    /* ── Form fields ── */
    formGroup: {
        marginBottom: '18px',
    },
    label: {
        display: 'block',
        fontSize: '12.5px',
        fontWeight: '600',
        color: '#374151',
        marginBottom: '6px',
        letterSpacing: '0.01em',
    },
    requiredStar: {
        color: '#dc2626',
        marginLeft: '2px',
    },
    input: {
        width: '100%',
        height: '40px',
        padding: '0 12px',
        fontSize: '13.5px',
        color: '#111827',
        backgroundColor: '#fff',
        border: '1.5px solid #e5e7eb',
        borderRadius: '8px',
        outline: 'none',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
        boxSizing: 'border-box',
    },
    inputFocus: {
        borderColor: '#1a7d3e',
        boxShadow: '0 0 0 3px rgba(26,125,62,0.12)',
    },
    editorWrapper: {
        border: '1.5px solid #e5e7eb',
        borderRadius: '8px',
        overflow: 'hidden',
        background: '#fff',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
    },
    editorLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '12.5px',
        fontWeight: '600',
        color: '#374151',
        marginBottom: '6px',
        letterSpacing: '0.01em',
    },

    /* ── Footer ── */
    modalFooter: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '10px',
        padding: '14px 24px',
        borderTop: '1px solid #e5e7eb',
        background: '#fff',
        flexShrink: 0,
    },
    btnCancel: {
        padding: '8px 20px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#374151',
        backgroundColor: '#f3f4f6',
        border: '1.5px solid #e5e7eb',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
    },
    btnSave: {
        padding: '8px 22px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#fff',
        backgroundColor: '#1a7d3e',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
        boxShadow: '0 2px 6px rgba(26,125,62,0.3)',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
    },
};
